var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3545 22.8285C25.3545 17.1921 25.3545 8.05095 25.3545 4.04018C25.3545 2.93561 24.4591 2.04651 23.3545 2.04651H6.64551C5.54094 2.04651 4.64551 2.94194 4.64551 4.04651V25.9535C4.64551 27.0581 5.54094 27.9535 6.64551 27.9535H22.708",
    stroke: "#CCCCCC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingBackground);
export default __webpack_public_path__ + "static/media/loading-background.21e1406f4cf10426d0a8bc135e4f7ad5.svg";
export { ForwardRef as ReactComponent };